import __request__ from "routing/request";
export function listAll() {
  return __request__("GET", "/roles", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/roles", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function update(rolename, JSONbody) {
  return __request__("PUT", `/roles/${rolename}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function read(rolename) {
  return __request__("GET", `/roles/${rolename}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(rolename) {
  return __request__("DELETE", `/roles/${rolename}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getMembers(rolename) {
  return __request__("GET", `/roles/${rolename}/members`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function addMember(JSONbody, rolename, username) {
  return __request__("PUT", `/roles/${rolename}/members/${username}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function removeMember(rolename, username) {
  return __request__("DELETE", `/roles/${rolename}/members/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
